module.exports = __webpack_public_path__ + "static/apple-touch-icon-6187c7c8746394656cf382cdf48bcacd.png";